var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0009 0C5.37355 0 0.002932 4.27453 0.002932 9.55056C0.002932 11.7376 0.935673 13.7385 2.4826 15.3506C1.78441 17.1587 0.3313 18.6929 0.3073 18.7113C-0.00143177 19.0329 -0.0854329 19.5017 0.0912969 19.9056C0.270209 20.3094 0.678214 20.5714 1.12768 20.5714C4.0099 20.5714 6.28339 19.3913 7.64704 18.445C9.00197 18.8629 10.4638 19.1022 12.0009 19.1022C18.6283 19.1022 24 14.8266 24 9.54947C24 4.27453 18.6283 0 12.0009 0ZM12.0009 16.8978C10.7496 16.8978 9.51361 16.7094 8.32669 16.3424L7.26304 16.0122L6.34884 16.6455C5.67901 17.1089 4.76045 17.6275 3.65426 17.9773C3.99572 17.4218 4.32845 16.7971 4.587 16.1312L5.08337 14.8407L4.1179 13.8402C3.26916 12.9535 2.25242 11.4886 2.25242 9.55056C2.25242 5.50123 6.62594 2.20439 12.0009 2.20439C17.377 2.20439 21.7505 5.50123 21.7505 9.55056C21.7505 13.601 17.377 16.8978 12.0009 16.8978V16.8978Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.806bb3c2.svg";
export { ForwardRef as ReactComponent };